import { render, staticRenderFns } from "./w-input-box.vue?vue&type=template&id=3de66be2&"
import script from "./w-input-box.vue?vue&type=script&lang=js&"
export * from "./w-input-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports